<template>
  <section>
    <subscription-list :query="query" />
  </section>
</template>

<script>
import SubscriptionList from '@/components/company/SubscriptionList'

export default {
  name: 'Subscriptions',
  components: {
    SubscriptionList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
